import NoResultIcon from '@/common/assets/icons/NoResult-vheicle-part.svg?react';
import PointsItems from '@/common/components/adjusterReport/damagedPoints/PointsItems';
import Typography from '@/common/components/base/typography/Typography';
import { damagedPartsSelectedQueryOptions } from '@/common/components/camera/queries/damagedPartsSelected/damagedPartsSelectedQueryOptions';
import { FileRoleType } from '@/common/types/ApiResponseTypes.type';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const ImagePreviewDamagedPointsList = ({
  participantRoleType,
  damaged_id,
}: {
  participantRoleType: FileRoleType;
  damaged_id?: number;
}) => {
  const { id } = useParams();

  const {
    resetDamagedPoints,
    damagedPoints,
    removeDamagedPoint,
    updateDamagedPoints,
  } = useDamagedPoints();

  const { data: selectedDamagedPoints = [] } = useQuery({
    ...damagedPartsSelectedQueryOptions({
      params: {
        id: +id!,
        damaged_id,
        participantRoleType: participantRoleType,
      },
      enabled: true,
    }),

    select: (data) =>
      data.map((item) => ({
        id: item.id,
        name: item.name,
        side: item?.side.fa_const,
        disabled: true,
      })),
  });

  useEffect(() => {
    resetDamagedPoints();
    return () => {
      resetDamagedPoints();
    };
  }, []);

  useEffect(() => {
    if (selectedDamagedPoints.length) {
      updateDamagedPoints?.(
        selectedDamagedPoints.map((item) => ({
          id: item.id.toString(),
          name: item.name,
          side: item.side,
          value: true,
          disabled: item.disabled,
        })),
      );
    }
  }, [selectedDamagedPoints]);

  const hasLocalPoints = !!damagedPoints.find((item) => !item.disabled);
  const hasServerPoints = !!selectedDamagedPoints?.length;

  return (
    <Box
      display="flex"
      h={400}
      mt={32}
      borderRadius={8}
      border="1px dashed"
      borderColor="gray-1"
      overflow="auto"
    >
      <Flex flexDirection="column" alignItems="start" gap={16} w="100%" p={16}>
        <Typography color="purple-1" textStyle="b2">
          لیست نقاط آسیب‌دیده
        </Typography>
        <Box bg="green-4" px={8} borderRadius={8} mt={8}>
          <Typography color="green" textStyle="b3">
            نقاط آسیب‌دیده جدید
          </Typography>
        </Box>

        {hasLocalPoints ? (
          damagedPoints.map((item) => {
            if (item.disabled) return;
            return (
              <PointsItems
                key={item.id}
                item={item}
                removePoint={() => removeDamagedPoint?.(item)}
                removeAble={true}
              />
            );
          })
        ) : (
          <Box
            w="100%"
            h="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={16}
          >
            <NoResultIcon />
            <Typography color="black-3" textStyle="b2">
              نقطه‌ی آسیب‌دیده‌ای ثبت نشده است.
            </Typography>
          </Box>
        )}

        <Box bg="yellow-1" px={8} borderRadius={8} mt={8}>
          <Typography color="yellow" textStyle="b3">
            نقاط آسیب‌دیده ثبت شده
          </Typography>
        </Box>

        {hasServerPoints &&
          selectedDamagedPoints.map((item) => (
            <PointsItems
              key={item.id}
              item={{
                ...item,
                id: item.id.toString(),
                side: item.side,
              }}
              removeAble={false}
            />
          ))}
      </Flex>
    </Box>
  );
};

export default ImagePreviewDamagedPointsList;
